import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { FormButtons, FileUpload, FormRow, Map, TagsInput } from '../controls';

const ServiceSchema = Yup.object().shape({
  serviceName: Yup.string().required('Service name is required'),
  type: Yup.string().required('Service type is required'),
});

export function ServiceForm({
  service,
  types,
  handleSave,
  handleLocationChange,
  onFileUpload,
  onFileDelete,
  handleRemove,
}) {
  const defaultValues = {
    serviceName: service.serviceName || '',
    serviceDescription: service.serviceDescription || '',
    type: service.type || '',
  };

  const fileList = [];

  if (service && service.photoURL) {
    fileList.push({
      uid: '-1',
      name: service.servicePhoto,
      url: service.photoURL,
      status: 'done',
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={handleSave}
      validationSchema={ServiceSchema}
    >
      {() => (
        <Form>
          <div className="flex">
            <div className="w-3/4 p-4">
              <FormRow label="Service Name" errorName="serviceName">
                <Field type="text" name="serviceName" placeholder="Name" />
              </FormRow>
              <FormRow label="Type" errorName="type">
                <Field
                  name="type"
                  render={({ field, form: { setFieldValue } }) => (
                    <TagsInput
                      value={field.value}
                      placeholder="Select or enter a type"
                      options={
                        Array.isArray(types)
                          ? types
                          : Object.values(types ?? {})
                      }
                      onChange={(v) => setFieldValue('type', v)}
                    />
                  )}
                />
              </FormRow>
            </div>
            <div className="w-1/4 p-4">
              <div className="w-full">
                <FileUpload
                  fileList={fileList}
                  onFileUpload={onFileUpload}
                  onFileDelete={onFileDelete}
                />
              </div>
            </div>
          </div>
          <FormRow label="Description">
            <Field
              component="textarea"
              name="serviceDescription"
              placeholder="Service Description..."
            />
          </FormRow>
          <FormRow>
            <Map
              location={service.location}
              handleClick={handleLocationChange}
            />
          </FormRow>
          <FormButtons
            showDelete={service.serviceId}
            title="Service"
            onDelete={handleRemove}
          />
        </Form>
      )}
    </Formik>
  );
}
